import Component from '../inherited/Component'

export default class SetValue extends Component {
    constructor (elem, theme, options, ctx) {
      super(elem, theme, options, ctx)
      this._linkedElem = document.querySelector(this._options.target)
    }

    async mount () {
      if(!this._linkedElem) return
      this._elem.addEventListener(this._options.on, e => {
        this._linkedElem.value = this._options.value
        this._linkedElem.dispatchEvent(new Event("change", { bubbles: true }))
      })
    }

}